import {
  SkeletonView as SkeletonViewBase,
  SkeletonViewProps as SkeletonViewPropsBase,
} from "react-native-ui-lib";
import { VariantTypes } from "../../utilities/text/types";
import { variantMap } from "../../utilities/text/variant-map";

export interface SkeletonViewProps extends SkeletonViewPropsBase {
  /**
   * Sets the height of the skeleton view based on the text variant.
   * @default body
   */
  textVariant?: VariantTypes;
}

/**
 * @description: Allows showing a temporary skeleton view while your real view is loading.
 * @notes: View requires installing the 'react-native-shimmer-placeholder' and 'expo-linear-gradient' library
 */
export function SkeletonView({
  textVariant = "body",
  ...props
}: SkeletonViewProps) {
  const height = variantMap[textVariant];

  return (
    <SkeletonViewBase
      height={height}
      {...props}
      colors={undefined}
      shimmerStyle={{ width: "100%" }}
    />
  );
}
